<template>
  <div class="d-flex flex-column h-100">
    <subtitle-component>
      <span class="mr-2">{{
        $t("message.reviews.analyst.subtitleRatings")
      }}</span>
      <TooltipIcon>
        {{ $t("message.reviews.analyst.subtitleRatingsTooltip") }}
      </TooltipIcon>
    </subtitle-component>
    <v-card class="rating-chart-card">
      <div class="rating-chart-wrapper" v-if="stats && stats.count">
        <div class="rating-chart-container">
          <template v-if="stats && stats.rating_distribution">
            <RatingDoughnutChart
              :rating-distribution="stats.rating_distribution"
            ></RatingDoughnutChart>
            <div class="chart-inside">
              <div class="chart-inside-label">
                {{ $t("message.reviews.analyst.allReviews") }}
              </div>
              <div class="chart-inside-value">{{ stats.count | number }}</div>
            </div>
          </template>
        </div>
        <ReviewsAnalystRatingsChartLegend
          v-if="stats && stats.rating_distribution"
          :rating-distribution="stats.rating_distribution"
        ></ReviewsAnalystRatingsChartLegend>
      </div>
      <NoData
        :fill="true"
        :description="$t('message.reviews.analyst.noDataDescription')"
        v-else
      ></NoData>

      <SectionLoader :status="loading" :opacity="1" />
    </v-card>
  </div>
</template>

<script>
import SubtitleComponent from "@/components/ui/Subtitle/Subtitle.component.vue";
import RatingDoughnutChart from "@/components/Reviews/RatingDoughnutChart";
import SectionLoader from "@/components/Loader/SectionLoader";
import ReviewsAnalystRatingsChartLegend from "@/components/Reviews/Analyst/ReviewsAnalystRatingsChartLegend";
import NoData from "@/components/ui/NoData";
import TooltipIcon from "@/components/ui/TooltipIcon";

export default {
  name: "ReviewsAnalystRatingsChart",
  components: {
    SubtitleComponent,
    RatingDoughnutChart,
    SectionLoader,
    ReviewsAnalystRatingsChartLegend,
    NoData,
    TooltipIcon
  },
  props: {
    stats: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-chart-card {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 30px;

  .rating-chart-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    margin: 0 auto;
    flex-wrap: wrap;
  }
}

.rating-chart-container {
  position: relative;
  width: 300px;
  height: 300px;
}

.chart-inside {
  position: absolute;
  width: 136px;
  height: 136px;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 82px;
  left: 82px;

  .chart-inside-label {
    @include font-size(12px);
    line-height: 15px;
    color: $chart-inside-label-color;
  }

  .chart-inside-value {
    @include font-size(30px);
    font-weight: bold;
    line-height: 37px;
    letter-spacing: -0.02em;
    color: $grey-darker;
    text-align: center;
  }
}
</style>
